// John Eldhose 20190429
import React, { Component } from 'react';
import { Typography } from '@material-ui/core';
import { setLoginPage } from './lib/LoginPage';
import DemoTab from './lib/DemoTab';

class TeaserDemo extends Component {

  handleDemo = (tab, prod) => {
    setLoginPage({ url: '/demo', opts: [tab, prod] });
    window.location = '/signup';
  }

  render() {
    return (
      <div>
        <Typography variant='display1'>
          <center><font color='#385687'>Demo Carlson Products</font></center>
        </Typography>
        <p />
        <DemoTab handleDemo={this.handleDemo} />
      </div>
    );
  }
}

export default TeaserDemo;



// WEBPACK FOOTER //
// ./src/components/TeaserDemo.js